import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { TemplateState, templateReducer } from '../../features/super-admin/templates/store';

export interface AppState {
  templates: TemplateState;
}

export const reducers: ActionReducerMap<AppState> = {
  templates: templateReducer
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
